module.exports = __webpack_public_path__ + "static/looking-76034aca8548843a7621198519f7e8d2.png";